import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    backgroundColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1
  },
  Id: {
    width: "10%",
  },
  Clientname: {
    width: "50%",
  },
  Inamount: {
    width: "20%",
  },
  Balance: {
    width: "20%",
  }
});

const InvoiceTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.Id}> Id </Text>
    <Text style={styles.Clientname}> Client </Text>
    <Text style={styles.Inamount}> Invoice </Text>
    <Text style={styles.Balance}>Balance</Text>   
  </View>
);
  
export default InvoiceTableHeader;
